import Vue from 'vue'
import VueRouter from 'vue-router'
import Part from '../views/Part.vue'
import SpecificParts from '../views/Parts.vue'
import GeneralParts from '../views/GeneralParts.vue'
import PartRegister from '../views/PartRegister.vue'
import Product from '../views/Product.vue'
import SpecificProducts from '../views/Products.vue'
import GeneralProducts from '../views/GeneralProducts.vue'
import GeneralPart from '../views/GeneralPart.vue'
import GeneralProduct from '../views/GeneralProduct.vue'
import Participant from '../views/Participant.vue'
import ProductRegister from '../views/ProductRegister.vue'
import Contract from '../views/Contract.vue'
import GettingStarted from '../views/GettingStarted.vue'
import AccountRegister from '../views/AccountRegister.vue'
import store from '../store/index'
import { load_contract } from '../utils/init'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'GettingStarted',
    alias: '/getting-started',
    component: GettingStarted
  },
  {
    path: '/account-register',
    name: 'AccountRegister',
    alias: '/account-register',
    component: AccountRegister
  },
  {
    path: '/contract',
    name: 'Contract',
    component: Contract
  },
  {
    path: '/parts',
    name: 'Parts',
    component: GeneralParts
  },
  {
    path: '/:id/parts',
    name: 'SpecificParts',
    component: SpecificParts
  },
  {
    path: '/:id/parts/:partid',
    name: 'SpecificPart',
    component: Part
  },
  {
    path: '/:id/parts/register',
    name: 'Parts/register',
    component: PartRegister
  },
  {
    path: '/parts/:id',
    name: 'GeneralPart',
    component: GeneralPart
  },
  {
    path: '/products',
    name: 'Products',
    component: GeneralProducts
  },
  {
    path: '/:id/products',
    name: 'SpecificProducts',
    component: SpecificProducts
  },
  {
    path: '/:id/products/:productid',
    name: 'SpecificProduct',
    component: Product
  },
  {
    path: '/products/register',
    name: 'Products/register',
    component: ProductRegister
  },
  {
    path: '/products/:id',
    name: 'GeneralProduct',
    component: GeneralProduct
  },
  {
    path: '/contract',
    name: 'Contract',
    component: Contract
  },
  {
    path: '/participant',
    name: 'Participant',
    component: Participant
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  const contracts = store.state.contracts
  const accounts = store.state.accounts

  if (!contracts.Proxy) {
    const res = await load_contract()
    store.commit('load_contract', res)

    next()
  }
  console.log(to)
  if (
    to.fullPath === '/' ||
    to.fullPath === '/getting-started' ||
    to.fullPath === '/parts' ||
    to.fullPath === '/products' ||
    to.fullPath === '/account-register' ||
    to.matched[0].path === '/parts/:id' ||
    to.matched[0].path === '/products/:id'
  )
    return next()

  if (!accounts) {
    if (sessionStorage.getItem('address'))
      store.commit('load_account', sessionStorage.getItem('address').toString())

    next()
  }

  if (!sessionStorage.getItem('private_key')) {
    store.commit('load_modal', { privateKey: true })

    next()
  }

  next()
})

export default router
